export default "__VITE_ASSET__DDijUMfs__"